//
//  src/layouts/default/contact/wizard/error/Error.js
//
import * as React from "react";
import EnquireOutcomeError from "../../../../../components/enquire/EnquireOutcomeError";
import "./Error.css";

export default function WizardError() {
    return (
        <EnquireOutcomeError
            source="wizard"
            message={
                <p>
                    Something went wrong sending your enquiry.<br />
                    Please try again, or email me directly at{" "}
                    <a href="mailto:jeff@jefftattooer.com">jeff@jefftattooer.com</a>.
                </p>
            }
        />
    );
}
